import { mapValuesDeep } from "../map-values-deep";
import xss from "xss";

const options = {
    singleQuotedAttributeValue: true,
    whiteList: {
        a: ["href", "target", "aria-label"],
        img: ["src"],
        source: ["src", "type"],
        b: ["aria-label"],
        br: [],
        span: ["aria-label"],
        ol: [],
        ul: [],
        li: [],
        strong: [],
        u: [],
        i: [],
        em: [],
        p: [],
    },
};

export const withSanitizationDefault = <T>(replyParsed: T): T => {
    return mapValuesDeep(replyParsed, (value: any) => {
        return typeof value === "string" ? xss(value, options) : value;
    });
};

export const withSanitization = <T>(replyParsed: T): T => {
    return mapValuesDeep(replyParsed, (value: any) => {
        if (typeof value === "string") {
            return xss(value, options);
        } else if (Array.isArray(value)) {
            return value.map((item) => withSanitization(item));
        } else if (typeof value === "object" && value!== null) {
            return withSanitization({...value});
        } else {
            return value;
        }
    });
};
